import { Routes } from '@angular/router';
import { authGuard } from '@core/guards/auth.guard';
import { loginGuard } from '@core/guards/login.guard';
import { Role } from 'portal-shared';

// Application routes
// IMPORTANT: Order matters! Specific routes (admin, login) must come before wildcard vendor routes
export const routes: Routes = [
  // Auth routes - manual login page (must be before wildcard vendor routes)
  {
    path: 'login',
    loadComponent: () =>
      import('@core/auth/login.component').then((m) => m.LoginComponent),
    canActivate: [loginGuard],
    title: 'AR Connect - Login',
  },
  // Auth callback route for OIDC (must be before wildcard vendor routes)
  {
    path: 'auth-callback',
    loadComponent: () =>
      import('@core/auth/auth-callback.component').then(
        (m) => m.AuthCallbackComponent,
      ),
    title: 'AR Connect - Authenticating...',
  },
  // Privacy policy route (must be before wildcard vendor routes)
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('@shared/pages/privacy-policy/privacy-policy.component').then(
        (m) => m.PrivacyPolicyComponent,
      ),
    title: 'Privacy Policy - AR Connect',
  },
  // Admin routes (must be before wildcard vendor routes)
  {
    path: 'admin',
    loadChildren: () =>
      import('@features/admin/admin.routes').then((m) => m.adminRoutes),
    canMatch: [authGuard],
    data: {
      requiredRoles: [Role.ADMIN, Role.SYS_ADMIN],
    },
  },
  // Sysadmin routes — SYS_ADMIN only
  {
    path: 'sysadmin',
    loadChildren: () =>
      import('@features/sysadmin/sysadmin.routes').then(
        (m) => m.sysadminRoutes,
      ),
    canMatch: [authGuard],
    data: {
      requiredRoles: [Role.SYS_ADMIN],
    },
  },
  // Unauthorized route - redirect back to login
  {
    path: 'unauthorized',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  // Default redirect based on user role
  {
    path: '',
    canMatch: [authGuard],
    loadComponent: () =>
      import('@core/auth/role-redirect.component').then(
        (m) => m.RoleRedirectComponent,
      ),
    pathMatch: 'full',
  },
  // Viewer/Vendor routes - dynamic vendor paths at root level
  // IMPORTANT: This must come after all specific routes (admin, login, etc)
  // because it uses wildcard matching for vendor slugs
  {
    path: '',
    loadChildren: () =>
      import('@features/viewer/viewer.routes').then((m) => m.viewerRoutes),
    canMatch: [authGuard],
  },
];
